const subnavbarData = [
    {to: '#home', content: 'HOME'},
    {to: '#Categories', content: 'CATEGORIES'},
    {to: '#Slider', content: 'PRODUCTS'},
    {to: '#AboutUs', content: 'ABOUT US'},
    {to: '#Gallery', content: 'GALLERY'},
    {to: '#Testimonials', content: 'TESTIMONIALS'},
    {to: '#Contact', content: 'CONTACT US'},
]



export default subnavbarData;